import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { mergeStorage, putStorage } from "hooks/useStorage";

const UniversityApi = {
    getMyUniversity: async () => {
        try {
            const { data: response } = (await axios.get("/my-university")) as any;
            mergeStorage("universities", { [response.id]: response });
            putStorage("myUniversityId", response.id);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("6vyaoixm7op"));
        }
    },
    updateMyUniversity: async (data: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put("/universities", data)) as any;
            await UniversityApi.getMyUniversity();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("xu1cfg7ro2d"));
        }
    },
    getAllUniversitiesData: async () => {
        try {
            const { data: universities } = (await axios.get("/universities/all")) as any;
            mergeStorage(`universities`, _.keyBy(universities, `id`));
            const { data: dormitories } = (await axios.get("/dormitories/all")) as any;
            mergeStorage(`dormitories`, _.keyBy(dormitories, `id`));
            const { data: rooms } = (await axios.get("/rooms/all")) as any;
            mergeStorage(`rooms`, _.keyBy(rooms, `id`));
            return;
        } catch (error) {
            throw AlertsService.showError(t("kxz5dhn1ckg"));
        }
    },
    // Для админа - получить все университеты включая скрытые
    getAllUniversitiesAdmin: async () => {
        try {
            const { data: universities } = (await axios.get("/admin/all-universities")) as any;
            mergeStorage(`universities`, _.keyBy(universities, `id`));
            return universities;
        } catch (error) {
            throw AlertsService.showError(t("kxz5dhn1ckg"));
        }
    },
};

export default UniversityApi;
